import React from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  CardContent,
  Grid,
  Card as MuiCard,
  LinearProgress,
  Typography,
} from "@mui/material";

import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";

import { getNextCode } from "src/services/generalService";
import { DefaultService } from "src/services/defaultService";
import { getCaption } from "src/utils/dictionary";

//import TestList from "./TestList";
import AMIndexList from "src/pages/components/AMIndexList";

const Card = styled(MuiCard)(spacing);

function SubLedgers({ menuItemCode }) {
  const defaultService = new DefaultService("SubLedgers");

  //#region Api Calls
  const getNextCodeFunc = async () => {
    const { data } = await getNextCode(menuItemCode, "code", "");
    return data || "";
  };

  const getByIdFunc = async (id) => {
    const { data } = await defaultService.get(menuItemCode, id);
     //Remove id if rendered from server to keep id as it comes from url and not enter in infinite loop
    //also if not remoced copy form will not work
    if (data) {
      delete data.id;
      delete data.ID;
      delete data.Id;
      delete data.iD;
    }
    return data;
  };

  const saveFormFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.save(menuItemCode, formData);
    return data;
  };

  const deleteFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.delete(menuItemCode, formData);
    return data;
  };
  //#endRegion

  const {
    state: values,
    indexColumns,
    renderFormHeader,
    renderFormInput,
    preLoaded,
    filterControls,
    formControls,
  } = useForm({
    menuItemCode: menuItemCode,
    nextCodeField: "code",
    getNextCodeFunc: getNextCodeFunc,
    getByIdFunc: getByIdFunc,
    saveFunction: saveFormFunction,
    deleteFunction: deleteFunction,
  });

  if (!preLoaded) return <LinearProgress my={2} />;

  const mainData = (
    <Card mb={6}>
      <CardContent>
        <Grid container spacing={4}>
          {renderFormInput("code", "text", {
            // disabled: true,
            style: { maxWidth: 100 },
          })}
          {renderFormInput("arbName")}
          {renderFormInput("engName")}
          {renderFormInput("notActive", Enums.ControlType.CheckBox)}
          {renderFormInput("parentLedgerID", Enums.ControlType.AutoSearch)}
          {renderFormInput("notes")}
          {renderFormInput("subLedgerTypeId", Enums.ControlType.AutoSearch)}
          {renderFormInput("zatcaInvoiceTypeID", Enums.ControlType.AutoSearch)}
          {renderFormInput("taxRegistrationNumber")}
          {renderFormInput("crn")}
         {(!formControls["cityID"]?.isHidden
|| !formControls["districtName"]?.isHidden
|| !formControls["streetName"]?.isHidden
|| !formControls["buildingNumber"]?.isHidden
|| !formControls["secondaryNumber"]?.isHidden
|| !formControls["additionalStreetAddress"]?.isHidden
|| !formControls["postalCode"]?.isHidden
         )
          && (
          <Grid item xs={12}>
            <Typography variant="button" gutterBottom color="primary">
              {getCaption("address_information")}
            </Typography>
          </Grid>)}
          {renderFormInput("cityID", Enums.ControlType.AutoSearch)}
          {renderFormInput("districtName")}
          {renderFormInput("streetName")}
          {renderFormInput("buildingNumber")}
          {renderFormInput("secondaryNumber")}
          {renderFormInput("additionalStreetAddress")}
          {renderFormInput("postalCode")}
          {(!formControls["contactPersonName"]?.isHidden
|| !formControls["email"]?.isHidden
|| !formControls["contactPhone"]?.isHidden
|| !formControls["contactPhone2"]?.isHidden
         )
          && (
          <Grid item xs={12}>
            <Typography variant="button" gutterBottom color="primary">
              {getCaption("contact_information")}
            </Typography>
          </Grid> )}
          {renderFormInput("contactPersonName")}
          {renderFormInput("email")}
          {renderFormInput("contactPhone")}
          {renderFormInput("contactPhone2")}
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <React.Fragment>
      {renderFormHeader()}
      {!values.id && indexColumns && !!indexColumns.length && (
        <AMIndexList
          key={indexColumns.length}
          columns={indexColumns}
          filterControls={filterControls}
          menuItemCode={menuItemCode}
          getAll={defaultService.getAll}
        />
      )}
      {!!values.id && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {mainData}
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
}

export default SubLedgers;
